import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles({
    root: {
        margin: "20px auto",
        display: "block",
    },
});
